let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bwo3Q")).then(() => parcelRequire('1x4MN'));